import React from 'react';
import { Box } from '@mui/material';

import LOGO_IMG from 'assets/logo/logo_black.svg';

const Footer = () => (
  <footer className="footer">
    <Box alignItems="center" display="flex" justifyContent="flex-end" px={2}>
      <Box alignItems="center" className="copyright" display="inline-flex" gap={1}>
        &copy; {new Date().getFullYear()}&nbsp;
        <span>Powered by</span>
        <a href="https://sectrify.com/" rel="noreferrer" style={{ display: 'inline-flex' }} target="_blank">
          <img src={LOGO_IMG} alt="Sectrify" style={{ display: 'block', height: 16, width: 'auto' }} />
        </a>
      </Box>
    </Box>
  </footer>
);

export default Footer;
